<template>
  <div>
    <el-tooltip :content="$t('accountProfileDetails.statusChange.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="primary" @click="modal = true" class="zi_100">
        <span class="mdi mdi_icon mdi-24px mdi-pencil-outline"/></base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('accountProfileDetails.statusChange.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('accountProfileDetails.statusChange.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('accountProfileDetails.statusChange.form.status')
              }}</label>
            <div class="col-md-9">
              <base-checkbox
                inline
                disabled
                v-model="formDetails.suspend"
              >
                {{ suspended() }}

              </base-checkbox>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('accountProfileDetails.statusChange.form.changeReason')
              }}</label>
            <div class="col-md-9">
              <base-input :error="getError('changeReason')">
                <textarea class="form-control"
                          name="changeReason"
                          data-vv-as="'changeReason'"
                          :placeholder="$t('accountProfileDetails.statusChange.form.changeReasonPlaceholder')"
                          v-validate="modelValidations.required"
                          v-model="formDetails.change_reason"
                          rows="2"/>
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('accountProfileDetails.statusChange.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {mapActions, mapState} from "vuex";
import swal from "sweetalert2";

export default {
  name: 'changeAccountStatusBtn',
  components: {
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        suspend: this.account.status !== 'suspended',
        change_reason: ''
      },
      modelValidations: {
        required: {
          required: true
        },
      }
    }
  },
  props: {
    account: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapState({
      updating: state => state.account.updating,
      error: state => state.account.error,
      data: state => state.account.data,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
  },
  methods: {
    ...mapActions(['UpdateAccountStatus', 'LoadAccountAuditLogs']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    suspended: function() {
      if (this.formDetails.suspend) {
        return this.$t('accountProfileDetails.statusChange.form.markedSuspend')
      }
      return this.$t('accountProfileDetails.statusChange.form.markedRestore')
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    update: function () {

      swal({
        title: this.$t('accountProfileDetails.statusChange.confirm.confirmTitle'),
        text: `'${this.formDetails.suspend ? 'suspend' : 'restore'}'`,
        confirmButtonText: this.$t('accountProfileDetails.statusChange.confirm.actionBtnLabel'),
        cancelButtonText: this.$t('accountProfileDetails.statusChange.confirm.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-primary',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.UpdateAccountStatus({id: this.account.id, data: this.formDetails}).then(() => {
            if (this.error != null) {
              this.alert = true
              // got error, don't reset form
            } else {
              this.LoadAccountAuditLogs({id: this.account.id, query: {id: "", filter: "", action_result: ""}})
              if (this.formDetails.suspend === true) {
                this.$notify({
                  type: 'success',
                  message: this.$t('accountProfileDetails.statusChange.accountSuspendedNotification', this.formDetails),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
              } else {
                this.$notify({
                  type: 'success',
                  message: this.$t('accountProfileDetails.statusChange.accountRestoredNotification', this.formDetails),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
              }
              this.resetForm();
            }
          });
        }
      });


    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        suspend: this.account.status !== 'suspended',
        change_reason: ''
      };

      // reset validation errors
      this.$validator.reset()
    }
  },
}
</script>
